import type { ApiClient } from "./client";
import type {
  RecomputeResponse,
  RemindFilter,
  RemindPreview,
  RemindResult,
  SprintDetail,
  SprintDetailResponse,
  SprintListItem,
  SprintListResponse,
} from "./types";

export async function listSprints(client: ApiClient, projectKey: string): Promise<SprintListItem[]> {
  const r = await client.get<SprintListResponse>(`/projects/${encodeURIComponent(projectKey)}/sprints`);
  return r.sprints;
}

export async function getSprint(
  client: ApiClient,
  projectKey: string,
  sprintId: number | string,
): Promise<SprintDetail> {
  const r = await client.get<SprintDetailResponse>(
    `/projects/${encodeURIComponent(projectKey)}/sprints/${encodeURIComponent(String(sprintId))}`,
  );
  return r.sprint;
}

export async function recomputeSprint(
  client: ApiClient,
  projectKey: string,
  sprintId: number | string,
): Promise<RecomputeResponse> {
  return client.post<RecomputeResponse>(
    `/projects/${encodeURIComponent(projectKey)}/sprints/${encodeURIComponent(String(sprintId))}/recompute`,
  );
}

function remindPath(projectKey: string, sprintId: number | string): string {
  return `/projects/${encodeURIComponent(projectKey)}/sprints/${encodeURIComponent(String(sprintId))}/remind`;
}

export async function previewRemind(
  client: ApiClient,
  projectKey: string,
  sprintId: number | string,
  filter: RemindFilter,
): Promise<RemindPreview> {
  return client.post<RemindPreview>(remindPath(projectKey, sprintId), {
    filter,
    dry_run: true,
  });
}

export async function sendRemind(
  client: ApiClient,
  projectKey: string,
  sprintId: number | string,
  filter: RemindFilter,
  // `force` overrides the server's quiet-hours guard (the "Send anyway" path).
  // The per-send cooldown still applies server-side.
  force = false,
): Promise<RemindResult> {
  return client.post<RemindResult>(remindPath(projectKey, sprintId), {
    filter,
    dry_run: false,
    force,
  });
}
